import { Component } from '@angular/core';

/** Loading placeholder shaped like the card row: three conversion cards. */
@Component({
  selector: 'ifbp-conversion-metrics-skeleton',
  templateUrl: './conversion-metrics-skeleton.component.html',
  styleUrls: ['./conversion-metrics-skeleton.component.scss'],
  standalone: false,
})
export class ConversionMetricsSkeletonComponent {
  readonly cards = [0, 1, 2];
  readonly cardTheme = { height: '8rem', 'border-radius': '1rem', margin: 0 };

  trackByIndex(index: number): number {
    return index;
  }
}
